"use cleint";

import { NewQuestionApiReturn } from "@/@types/exam-question";
import { QuestionUpdateSchemaType } from "@/lib/zod/types";
import api from "@/services/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

export function useUpdateQuestion() {
  const queryClient = useQueryClient();
  const abortController = useRef<AbortController | null>(null);

  const mutation = useMutation({
    mutationFn: async (question: QuestionUpdateSchemaType) => {
      abortController.current = new AbortController();

      const { data } = await api.put<NewQuestionApiReturn>(
        "/questions",
        question
      );

      return data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["/assessment-by-id"],
      });
    },
  });

  return { ...mutation, abort: () => abortController.current?.abort() };
}
